<template>
  <!--
      	作者：luoyiming
      	时间：2019-06-04
      	描述：插件中心-分销-分销设置-佣金设置
      -->
  <div class="product-add mt30">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <el-form-item label="分销类型：" >
        <el-radio-group v-model="form.commission_type" >
          <el-radio :label="'10'">统一返利</el-radio>
          <el-radio :label="'20'">按等级返利</el-radio>
        </el-radio-group>

      </el-form-item>
      <div v-if="form.commission_type ==20">
        <el-form-item label="佣金类型：" >
          <el-radio-group v-model="form.money_type" @change="changeGradeType">
            <el-radio :label="'10'">百分比</el-radio>
            <el-radio :label="'20'">固定金额</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="佣金设置：">
        <div style="max-width: 800px;">
          <el-table :data="gradeList" border  style="width: 100%">
            <el-table-column prop="name" label="会员等级">
            </el-table-column>
            <el-table-column prop="name" label="佣金设置" width="650px">
              <template v-slot="scope">
                  <el-input type="number" min="0" v-model="scope.row.first_money" class="max-w300">
                    <template slot="prepend">
                      一级佣金：
                    </template>
                    <template slot="append">
                      {{ unit }}
                    </template>
                  </el-input>
                  <el-input type="number" min="0" v-model="scope.row.first_point" class="max-w300" v-auth="'/plus/agent/point'">
                    <template slot="prepend">
                      一级积分：
                    </template>
                    <template slot="append">
                      {{ point_unit }}
                    </template>
                  </el-input>
                  <el-form-item v-if="basic.level >= 2">
                    <el-input type="number" min="0" v-model="scope.row.second_money" class="max-w300">
                      <template slot="prepend">
                        二级佣金：
                      </template>
                      <template slot="append">
                        {{ unit }}
                      </template>
                    </el-input>
                    <el-input type="number" min="0" v-model="scope.row.second_point" class="max-w300" v-auth="'/plus/agent/point'">
                      <template slot="prepend">
                        二级积分：
                      </template>
                      <template slot="append">
                        {{ point_unit }}
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item v-if="basic.level >= 3">
                    <el-input type="number" min="0" v-model="scope.row.third_money" class="max-w300">
                      <template slot="prepend">
                        三级佣金：
                      </template>
                      <template slot="append">
                        {{ unit }}
                      </template>
                    </el-input>
                    <el-input type="number" min="0" v-model="scope.row.third_point" class="max-w300" v-auth="'/plus/agent/point'">
                      <template slot="prepend">
                        三级积分：
                      </template>
                      <template slot="append">
                        {{ point_unit }}
                      </template>
                    </el-input>
                  </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
      </div>
      <div v-if="form.commission_type ==10">
        <el-form-item label="一级分销 "  v-if="basic.level >=1">
          <el-input v-model="form.first_money" type="number" class="max-w300">
            <template slot="prepend">
              一级佣金：
            </template>
            <template slot="append">
              %
            </template>
          </el-input>
          <el-input type="number" min="0" v-model="form.first_point" class="max-w300" v-auth="'/plus/agent/point'">
            <template slot="prepend">
              一级积分：
            </template>
            <template slot="append">
              %
            </template>
          </el-input>
          <div class="tips">分销比例范围 0% - 100%</div>
        </el-form-item>
        <el-form-item label="二级分销" v-if="basic.level >=2">
          <el-input v-model="form.second_money" type="number" class="max-w300">
            <template slot="prepend">
              二级佣金：
            </template>
            <template slot="append">
              %
            </template>
          </el-input>
          <el-input type="number" min="0" v-model="form.second_point" class="max-w300" v-auth="'/plus/agent/point'">
            <template slot="prepend">
              二级积分：
            </template>
            <template slot="append">
              %
            </template>
          </el-input>
          <div class="tips">分销比例范围 0% - 100%</div>
        </el-form-item>
        <el-form-item label="三级分销  " v-if="basic.level ==3">
          <el-input v-model="form.third_money" type="number" class="max-w300">
            <template slot="prepend">
              三级佣金：
            </template>
            <template slot="append">
              %
            </template>
          </el-input>
          <el-input type="number" min="0" v-model="form.third_point" class="max-w300" v-auth="'/plus/agent/point'">
            <template slot="prepend">
              三级积分：
            </template>
            <template slot="append">
              %
            </template>
          </el-input>
          <div class="tips">分销比例范围 0% - 100%</div>
        </el-form-item>
      </div>
      <el-form-item label="佣金支付：" v-auth="'/plus/agent/setting/commissionpay'">
        <el-radio-group v-model="form.is_pay" >
          <el-radio label="1">开启</el-radio>
          <el-radio label="0">关闭</el-radio>
        </el-radio-group>
	   </el-form-item>
     <el-form-item label="开启产品分销复购返佣：" v-auth="'/plus/agent/membercommission'">
         <el-radio-group v-model="form.is_open_product_member_commission" >
           <el-radio label="1">开启</el-radio>
           <el-radio label="0">关闭</el-radio>
         </el-radio-group>
      </el-form-item>
      <!--佣金转账-->
      <div class="common-form mt50" v-auth="'/plus/agent/setting/commissiontransfer'">佣金转账</div>
      <el-form-item label="是否开启佣金转账：" v-auth="'/plus/agent/setting/commissiontransfer'">
        <el-radio-group v-model="form.transfer_open">
          <el-radio :label="'1'">开启</el-radio>
          <el-radio :label="'0'">关闭</el-radio>
        </el-radio-group>
        <div class="lh18 mt10 gray9">
           <p> 注：佣金只能在分销商之间互转</p>
         </div>
      </el-form-item>
      <el-form-item label="转账手续费" v-auth="'/plus/agent/setting/commissiontransfer'">
        <el-input placeholder="请输入内容" type="number" min="0"  v-model="form.transfer_money" class="max-w460">
          <template slot="append">%</template>
        </el-input>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import PlusApi from '@/api/plus.js';

  export default {
    data() {
      return {
        /*form表单数据*/
        form: {
          money_type:'10',
          is_pay:'0',
          commission_type:'10',
          transfer_open:'0',
          is_open_product_member_commission: '0',
        },
        /*商品列表*/
        productList: [],
        /*加载完成*/
        loading: false,
        basic:{},
        gradeList:[],
        unit: '%',
        point_unit: '%',

      };
    },
    props: {
      settingData: Object
    },
    created() {
      if(this.settingData.data.commission.values.money_type == '20'){
        this.unit = '元';
        this.point_unit = '积分';
      }

      this.gradeList = this.settingData.gradeList;
      this.basic=this.settingData.data.basic.values;
      this.form=this.settingData.data.commission.values;

      let agent = this.form.alone_money_equity;
      let first_money =[];
      first_money= agent.first_money != '' ? JSON.parse(agent.first_money) : [];
      let second_money =[];
      second_money= agent.second_money != '' ? JSON.parse(agent.second_money) : [];
      let third_money =[];
      third_money= agent.third_money != '' ? JSON.parse(agent.third_money) : [];
      let first_point =[];
      first_point= agent.first_point != '' ? JSON.parse(agent.first_point) : [];
      let second_point =[];
      second_point= agent.second_point != '' ? JSON.parse(agent.second_point) : [];
      let third_point =[];
      third_point= agent.third_point != '' ? JSON.parse(agent.third_point) : [];
      this.gradeList.forEach(item=>{
        this.$set(item, 'first_money', first_money[item.grade_id]?first_money[item.grade_id]:0)
        this.$set(item, 'second_money', second_money[item.grade_id]?second_money[item.grade_id]:0)
        this.$set(item, 'third_money', third_money[item.grade_id]?third_money[item.grade_id]:0)
        this.$set(item, 'first_point', first_point[item.grade_id]?first_point[item.grade_id]:0)
        this.$set(item, 'second_point', second_point[item.grade_id]?second_point[item.grade_id]:0)
        this.$set(item, 'third_point', third_point[item.grade_id]?third_point[item.grade_id]:0)
      })

    },

    methods: {
      /*转JSON字符串*/
      convertJson(list,type){
        let obj={};

        list.forEach(item=>{
          if(type ==10){
            obj[item.grade_id]=item.first_money?item.first_money:0;
          }
          if(type ==20){
            obj[item.grade_id]=item.second_money?item.second_money:0;
          }
          if(type ==30){
            obj[item.grade_id]=item.third_money?item.third_money:0;
          }
          if(type ==40){
            obj[item.grade_id]=item.first_point?item.first_point:0;
          }
          if(type ==50){
            obj[item.grade_id]=item.second_point?item.second_point:0;
          }
          if(type ==60){
            obj[item.grade_id]=item.third_point?item.third_point:0;
          }
        });
        return JSON.stringify(obj);
      },
      /*提交表单*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        if(params.commission_type ==10){
          params.first_money = params.first_money?params.first_money:0;
          params.second_money = params.second_money?params.second_money:0;
          params.third_money = params.third_money?params.third_money:0;
          params.first_point = params.first_point?params.first_point:0;
          params.second_point = params.second_point?params.second_point:0;
          params.third_point = params.third_point?params.third_point:0;
        }
        if(params.commission_type ==20){
          params.alone_money_equity.first_money = self.convertJson(self.gradeList,10);
          params.alone_money_equity.second_money = self.convertJson(self.gradeList,20);
          params.alone_money_equity.third_money = self.convertJson(self.gradeList,30);
          params.alone_money_equity.first_point = self.convertJson(self.gradeList,40);
          params.alone_money_equity.second_point = self.convertJson(self.gradeList,50);
          params.alone_money_equity.third_point = self.convertJson(self.gradeList,60);
        }

        // console.log(params);
        // return;
        PlusApi.commission(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，设置成功',
              type: 'success'
            });

          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*换算单位*/
      changeGradeType: function(val) {
        if (val == '10') {
          this.unit = '%';
          this.point_unit = '%';
        } else {
          this.unit = '元';
          this.point_unit = '积分';
        }
      }

    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
  .max-w300 {
    max-width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/agent/setting/part/Commission.vue